import Graphs from '../Graphs';
import { scaleLinear, scaleBand } from 'd3-scale';
import { max, range } from 'd3-array';
import { select, mouse } from 'd3-selection';
import { transition } from 'd3-transition';
import { format } from 'd3-format';
import { axisLeft, axisBottom } from 'd3-axis';
import { isEqual } from 'lodash';
import moment from 'moment-timezone';

import './BarChart.css';

export default class BarChart extends Graphs {
  // overwrite the Graphs update method to add a behavior to range change method
  componentDidUpdate(props) {
    moment.tz.setDefault(this.props.filters.tz);
    if (!isEqual(props.data, this.props.data) || !isEqual(props.size, this.props.size)) {
      if (this.node) {
        select(this.node).selectAll('*').remove();
      }
      return this.renderChart();
    } else if (!isEqual(props.ranges, this.props.ranges)) {
      select(this.node)
        .selectAll('rect')
        .data(this.props.data)
        .style('fill', (d, i) => {
          if (this.props.ranges && !moment(d.date).isBetween(this.props.ranges[0], this.props.ranges[1], null, '[]')) {
            return '#eee';
          }
          return this.props.colorScheme[0]
        })
    }
    else
      return; // don't do any updates
  }

  renderChart = () => {
    const node = this.node;
    const dataMax = max(this.props.data.map(item => item.value));
    const dataValues = this.props.data.map(item => item.value);
    const padding = 20;
    const self = this;
    moment.tz.setDefault(this.props.filters.tz);
    global.transition = transition;

    const yScale = scaleLinear()
      .domain([0, dataMax])
      .range([this.props.size[1] - padding, padding]);

    const xScale = scaleBand()
      .domain(this.props.data.map(item => item.key))
      .rangeRound([0, this.props.size[0] - padding])
      .padding(0.5);


    select(node)
      .append("g")
      .attr("transform", `translate(${padding}, ${this.props.size[1] - padding/2})`)
      .attr("class", "axis x-axis")
      .call(axisBottom(xScale).tickSize(0).tickValues(xScale.domain().filter((d, i, arr) => (!(i%4) || arr.length < 12))));

    select(node)
      .selectAll('rect')
      .data(this.props.data)
      .enter()
      .append('rect');

    select(node)
      .selectAll('rect')
      .data(this.props.data)
      .exit()
      .remove();

    if (this.props.textAbove)
      select(node)
        .selectAll('text.bar-label')
        .data(this.props.data)
        .enter()
        .append('text')
        .attr('class', 'bar-label')
        .attr('transform', (d) => `translate(${xScale(d.key) + xScale.bandwidth()/2}, ${yScale(d.value) - padding})`)
        .attr('font-size', '0.8em')
        .text(function(d, i) {
          const dataValues = self.props.tooltipData ? self.props.tooltipData[i] : d;
          return `${format('0.3s')(dataValues.value)}`;
        });

    select(node)
      .selectAll('rect')
      .data(this.props.data)
      .style('fill', (d, i) => {
        if (this.props.ranges) {
          if (!moment(d.date).isBetween(this.props.ranges[0], this.props.ranges[1], null, '[]'))
            return '#333';
        }
        return this.props.colorScheme[0]
      })
      .attr('x', (d) => xScale(d.key) + padding)
      .attr('y', d => yScale(d.value))
      .attr('width', xScale.bandwidth())
      .on('mouseover', function() {
        tooltip.style("display", null);
        select(this).transition("hover").style('fill', 'teal');
      })
      .on('mouseout', function(d) {
        tooltip.style("display", "none");
        if (self.props.ranges && !moment(d.date).isBetween(self.props.ranges[0], self.props.ranges[1], null, '[]'))
          select(this).transition("hover-exit").style('fill', '#eee');
        else
          select(this).transition("hover-exit").style('fill', self.props.colorScheme[0]);

      })
      .on("mousemove", function(d, i) {
        var xPosition = mouse(this)[0] - 5;
        var yPosition = mouse(this)[1] - 5;
        tooltip.attr("transform", `translate(${xPosition-40}, ${yPosition+20})`);
        const dataValues = self.props.tooltipData ? self.props.tooltipData[i] : d;
        tooltip
          .select("text")
          .text(`${dataValues.key}: ${format('0.3s')(dataValues.value)}`)
          .attr("transform", `translate(${-10},0)`)
        tooltip
          .select('rect')
          .attr('width', () => tooltip.select('text').node().getComputedTextLength()+20)
          .attr('transform', `translate(${-30-tooltip.select('text').node().getComputedTextLength()/16}, 0)`)
      })
      .transition("enter")
      .delay((d, i) => i / this.props.data.length * 1000)
      .duration(500)
      .attr('height', d => yScale(0) - yScale(d.value));

    const tooltip = select(node).append("g")
      .attr("class", "tooltip")
      .style("display", "none");

    tooltip.append("rect")
      .attr("width", '20')
      .attr("height", 20)
      .attr("fill", "#333");

    tooltip.append("text")
      .attr("x", 30)
      .attr("dy", "1.2em")
      .style("text-anchor", "middle")
      .attr("font-size", "0.5em")
      .attr("fill", "#fff")

  }
}



// WEBPACK FOOTER //
// ./src/components/Graphs/BarChartComponent/BarChart.js